// extracted by mini-css-extract-plugin
module.exports = {"comparison":"ComparisonSection_comparison__oEB6F","container":"ComparisonSection_container__r913u"};